<template>
  <div id="app">
    <app-header/>

    <router-view/>

    <app-footer/>

    <cookie-consent/>
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    title: 'Mag. Harald Parrainer',
    titleTemplate: '%s - PSYCHOLOGISCHE PRAXIS',
    base: {target: '_blank', href: '/'},
    meta: [
      {charset: 'utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {
        name: 'description',
        content: 'Psychologische Praxis Mag. Harald Parrainer bietet Klinische Diagnostik, Behandlung & Beratung, Befunde & Gutachten, Sportpsychologie, Notfallpsychologie und Supervision.'
      },
      {
        property: 'og:title',
        content: 'PSYCHOLOGISCHE PRAXIS - Mag. Harald Parrainer',
        // following template options are identical
        // template: '%s - My page',
        template: chunk => `${chunk}`,
        vmid: 'og:title'
      },
      {
        property: 'og:description',
        content: ''
      },
      {
        property: 'og:type',
        content: 'website'
      },
      {
        property: 'og:url',
        content: ' https://www.psychologische-praxis-parrainer.at'
      },
      {
        property: 'og:image',
        content: ''
      }
    ],
    htmlAttrs: {
      lang: 'de'
    },
    bodyAttrs: {
      class: ['app']
    }
  }
}
</script>

<style lang="scss">
@import "assets/scss/basscss";
@import "assets/scss/variables";

// overwrite variables
$cookieconstent-padding: 1rem;
$cookieconstent-space: .7rem;
$cookieconstent-compliance-padding: .5rem 2rem;

$cookieconstent-compliance-color: #fff !default;
$cookieconstent-compliance-background: #000 !default;
$cookieconstent-compliance-border: 2px solid #000 !default;

// find more variables in /src/scss/_cookie-consent-variables.scss
// required and to get updates
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
// example or use it
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
@import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";

html {
  background-color: $primary-bg-color;

  p,
  li {
    line-height: 1.8rem;
  }

  @media screen and (max-width: $break-md) {
    .app {
      .heading-wrapper .h1.headline {
        font-size: 4rem;
        line-height: 4rem;
        bottom: calc(0% - 4.8rem);
        left: 0;
      }

      .content-wrapper {
        padding: 2rem;
        padding-top: 0;

        &.impressum {
          padding-top: 4rem;
        }
      }
    }
  }

  .app {
    font-family: $font-stack;
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: $primary-color;
    margin: 0;

    a {
      color: $primary-link-color;
      border-bottom: 1px solid $primary-link-color;
      text-decoration: none;
      box-sizing: border-box;
      white-space: nowrap;
      word-break: break-all;
      box-shadow: 0 1px $primary-link-color;

      &:hover {
        box-shadow: 0 1px $primary-link-color,
        0 2px $primary-link-color;
        -webkit-transform: translateX(0);
        transform: translateX(0);
        transition: .5s ease;
      }
    }

    .headline {
      font-family: $headline-font;
      font-weight: normal;
      font-style: normal;

      color: $secondary-color;

      &.black {
        color: black;
      }
    }

    .h1 {
      font-size: 3rem;
      line-height: 3rem;
    }

    @media (--breakpoint-sm) {
      .h1 {
        font-size: 6rem;
        line-height: 6rem;
        width: 100%;
        display: inline;
      }
    }
  }
}

.impressum {
  padding-top: 7rem;
}

.back-to-top {
  background-color: $dark;
  border-color: $dark;
  color: white;
  cursor: pointer;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  font-size: 1rem;
  font-family: $font-stack;
  font-weight: 200;
  outline: none;

  &:hover {
    background-color: white;
    color: $dark;
    transition: color 0.5s 0s ease;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue